var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 754,
    height: 535,
    viewBox: "0 0 754 535",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3070_198)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 754,
    height: 535,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3070_198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.678 21.6572H68.8307C58.1719 21.6572 49.5312 33.8976 49.5312 48.9969V506.937C49.5312 522.036 58.1719 534.277 68.8307 534.277H582.678C593.337 534.277 601.978 522.036 601.978 506.937V48.9969C601.978 33.8976 593.337 21.6572 582.678 21.6572Z",
    fill: "#FFE7C8"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 754,
    height: 535,
    rx: 50.0856,
    fill: "#FFE7C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.613 309.198H439.793V389.405H291.613V309.198Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.931 309.322C286.743 309.322 298.75 297.315 298.75 282.504C298.75 267.692 286.743 255.686 271.931 255.686C257.12 255.686 245.113 267.692 245.113 282.504C245.113 297.315 257.12 309.322 271.931 309.322Z",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.658 309.322C474.469 309.322 486.476 297.315 486.476 282.504C486.476 267.692 474.469 255.686 459.658 255.686C444.847 255.686 432.84 267.692 432.84 282.504C432.84 297.315 444.847 309.322 459.658 309.322Z",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.981 235.955C466.981 151.096 265.783 180.496 265.783 235.955V302.773C265.783 358.232 310.717 403 366.382 403C422.047 403 466.981 358.232 466.981 302.773V235.955Z",
    fill: "#FFB74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.022 295.913C413.428 295.913 419.431 289.909 419.431 282.504C419.431 275.098 413.428 269.095 406.022 269.095C398.617 269.095 392.613 275.098 392.613 282.504C392.613 289.909 398.617 295.913 406.022 295.913Z",
    fill: "#784719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.567 295.913C332.973 295.913 338.976 289.909 338.976 282.504C338.976 275.098 332.973 269.095 325.567 269.095C318.162 269.095 312.158 275.098 312.158 282.504C312.158 289.909 318.162 295.913 325.567 295.913Z",
    fill: "#784719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.702 121.595C308.751 121.595 225 160.428 225 346.556L292.001 389.406V268.891L404.563 203.277L439.404 248.805V389.406L506.405 334.504C506.405 297.011 500.375 140.342 403.223 140.342L393.843 121.595H365.702Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.503 268.709C502.483 268.709 499.803 271.384 499.803 275.396V228.587C499.803 169.742 451.562 121.595 392.601 121.595H332.3C328.28 121.595 325.6 124.27 325.6 128.282C325.6 132.294 328.28 134.969 332.3 134.969H392.601C444.192 134.969 486.402 177.097 486.402 228.587V295.457C486.402 299.469 489.082 302.144 493.102 302.144C497.123 302.144 499.803 299.469 499.803 295.457V308.831C499.803 334.91 479.032 355.64 452.902 355.64H365.8C361.78 355.64 359.1 358.315 359.1 362.327C359.1 366.339 361.78 369.014 365.8 369.014H452.902C486.402 369.014 513.203 342.266 513.203 308.831V275.396C513.203 271.384 510.523 268.709 506.503 268.709Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.592 255.686H499.888C492.513 255.686 486.479 261.72 486.479 269.095V295.913C486.479 303.288 492.513 309.322 499.888 309.322H506.592C513.967 309.322 520.001 303.288 520.001 295.913V269.095C520.001 261.72 513.967 255.686 506.592 255.686Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.796 376.367C373.201 376.367 379.205 370.364 379.205 362.958C379.205 355.552 373.201 349.549 365.796 349.549C358.39 349.549 352.387 355.552 352.387 362.958C352.387 370.364 358.39 376.367 365.796 376.367Z",
    fill: "#37474F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3070_198",
    x: -138.29,
    y: -166.164,
    width: 969.827,
    height: 930,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 20.869,
    dy: 20.869
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 104.345
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741667 0 0 0 0 0.741667 0 0 0 0 0.741667 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3070_198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3070_198",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3070_198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 754,
    height: 535,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact2);
export default __webpack_public_path__ + "static/media/contact2.5bd7e4cd4408754c9e1d9b0784ce3e5f.svg";
export { ForwardRef as ReactComponent };